module.exports = __webpack_public_path__ + "img/jaune-3.c18d67a5.png";